import { render, staticRenderFns } from "./ArrivalCertificationForm.vue?vue&type=template&id=4935d916&"
import script from "./ArrivalCertificationForm.vue?vue&type=script&lang=js&"
export * from "./ArrivalCertificationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports